export default "__VITE_ASSET__B$2XKst5__"